import { useMemo } from 'react';
import FormattedMessage from 'I18n/components/FormattedMessage';
import UIButton from 'UIComponents/button/UIButton';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import { useHasScope } from '../../../hooks/useHasScope';
import { PAYMENTS_MANUAL_EMAILS } from '../../../constants/scopes';
import { jsx as _jsx } from "react/jsx-runtime";
function SendEmailActionButton({
  isAccountEnabled,
  isManualPayment,
  disabled,
  openModal
}) {
  const canSendEmails = useHasScope(PAYMENTS_MANUAL_EMAILS);
  const validationMessage = useMemo(() => {
    if (!isAccountEnabled && !isManualPayment) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.noAccess.accountDisconnected"
      });
    }
    if (!canSendEmails) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.noAccess.default"
      });
    }
    if (disabled) {
      return /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.sendReceiptDisabledTooltip"
      });
    }
    return null;
  }, [canSendEmails, disabled, isAccountEnabled, isManualPayment]);
  return /*#__PURE__*/_jsx(UITooltip, {
    title: validationMessage,
    children: /*#__PURE__*/_jsx(UIButton, {
      "data-test-id": "payment-sidebar-actions--send-email",
      onClick: openModal,
      disabled: Boolean(validationMessage),
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "cardPaymentHighlight.paymentHighlight.sidebarActions.sendEmail.sendReceipt"
      })
    })
  });
}
export default SendEmailActionButton;